import axios from 'axios';

const BASE_URL = process.env.REACT_APP_CNPJ_BASE_URL;
const TOKEN = process.env.REACT_APP_CNPJ_TOKEN;

export const validateCNPJ = async (cnpj: string): Promise<boolean> => {
    try {
        const sanitizedCNPJ = cnpj.replace(/[^\d]/g, ''); // Remove caracteres não numéricos

        if (sanitizedCNPJ.length !== 14) {
            throw new Error('CNPJ inválido. Deve conter 14 dígitos.');
        }

        const url = `${BASE_URL}/?cnpj=${sanitizedCNPJ}&token=${TOKEN}`;

        const response = await axios.get(url, {
            timeout: 45000 // 45 segundos de timeout para corresponder ao CURLOPT_TIMEOUT
        });

        const result = response.data;

        if (result.return === 'OK') {
            console.log('Razão Social:', result.result.nome);
            result.result.atividades_secundarias.forEach((atividade: any) => {
                console.log(`${atividade.code} - ${atividade.text}`);
            });
            return true;
        } else {
            console.error('CNPJ não retornou com sucesso');
            return false;
        }
    } catch (error) {
        console.error('Erro ao validar o CNPJ:', error);
        return false;
    }
};
